import React from "react";
import { useLocation } from 'react-router-dom';
import { HTMLTemplate } from "@minerva-analytics/pantheon";
import { LegalContainer } from './Legal.styles';

const commonInfo = {
  dba: "Quickscope",
  domain: "https://www.quickscope.com",
  email: "help@thequickscope.com",
  name: "Quickscope",
  address1: "350 Lincoln Street",
  address2: "Suite 2400",
  state: "Hingham, MA 02043",
  country: "USA",
};

const legalInfo = {
  "/ccpa": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/CalPolicy.html`,
    variables: { ...commonInfo },
  },
  "/cookie": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/CookiePolicy.html`,
    variables: { ...commonInfo },
  },
  "/terms": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/Terms.html`,
    variables: { ...commonInfo },
  },
  "/privacy": {
    templateUrl: `https://storage.googleapis.com/minerva-legal/Privacy.html`,
    variables: { ...commonInfo },
  },
};

const Legal = () => {
  const { pathname } = useLocation();

  return (
    <LegalContainer>
      <HTMLTemplate {...legalInfo[pathname]} />
    </LegalContainer>
  );
};

export default Legal;
